import React, { useEffect } from "react";

import Input from "../../controls/Input";

import { useForm } from "../useForm";
import Button from "../../controls/Button";

const initialFValues = {
  name: "",
  email: "",
};

export default function MyAccountForm(props) {
  const { updateAccountDetails, userDetails } = props;

  var loading = false;

  const validate = (fieldValues = values) => {
    let temp = { ...errors };

    if ("name" in fieldValues) {
      temp.name = null;
      if (fieldValues.name === "") {
        temp.name = "This field is required.";
      }
    }

    if ("email" in fieldValues) {
      temp.email = null;
      if (fieldValues.email === "") {
        temp.email = "This field is required.";
      }
    }

    setErrors({
      ...temp,
    });

    if (fieldValues === values) {
      return Object.values(temp).every((x) => x === null);
    }
  };

  const { values, setValues, errors, setErrors, handleInputChange } = useForm(
    initialFValues,
    true,
    validate,
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      updateAccountDetails(values);
    }
  };

  useEffect(() => {
    setValues({
      name: userDetails.name,
      email: userDetails.email,
    });
  }, [userDetails]);

  return (
    <section className="overflow-hidden rounded-2xl border border-border-subtle bg-card shadow-soft">
      <div className="border-b border-border-subtle px-6 py-5">
        <h2 className="text-base font-semibold text-brand">
          Account details
        </h2>
        <p className="mt-1 text-sm text-slate-500">
          Update your name and email address.
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-5 p-6">
        <Input
          label="Name"
          name="name"
          onChange={handleInputChange}
          value={values.name}
          labelOn={true}
          type="text"
          error={errors.name}
        />

        <Input
          label="Email"
          name="email"
          onChange={handleInputChange}
          value={values.email}
          labelOn={true}
          type="email"
          error={errors.email}
        />

        <div className="flex justify-end border-t border-border-subtle pt-5">
          <Button type="submit" className="h-10 px-4" loading={loading}>
            Save changes
          </Button>
        </div>
      </form>
    </section>
  );
}
